import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getVendorRegistrationListUrl, GET_VENDOR_REGISTRATION_LIST, addVendorRegistrationUrl, ADD_VENDOR_REGISTRATION, UPDATE_VENDOR_REGISTRATION, DELETE_VENDOR_REGISTRATION, updateVendorRegistrationUrl, deleteVendorRegistrationUrl, detailsVendorRegistrationUrl, DETAILS_VENDOR_REGISTRATION, sendVendorUserCredUrl, SEND_VENDOR_CRED_REGISTRATION, insertVendorConfigurationUrl, INSERT_VENDOR_CONFIGURATION } from "../../../../utils/constants";


export const getVendorRegistrationList_action = (ExhibitionID, CompanyName, PersonName, ServiceID, Status) => async (dispatch) => {
    try {
        const params = {
            UserID: null,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            CompanyName: CompanyName != '' ? CompanyName : null,
            PersonName: PersonName != '' ? PersonName : null,
            ServiceID: ServiceID != '' ? parseInt(ServiceID) : null,
            Status: Status,
        }

        const res = await axiosGet(getVendorRegistrationListUrl, params, headers)

        dispatch({
            type: GET_VENDOR_REGISTRATION_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}


export const addVendorRegistration_action = (
    PrimaryEmail, Title_PersonIncharge, PersonIncharge, LastNamePersonIncharge, MobileNo, AlternateMobileNo, Telephone, Telephone1, CompanyName, Address1, Address2, City, State, Pin, CountryID, SecondaryEmail, Website, TeleFax, Designation, Title_Name_Of_CEO_MD_President_Owner, Name_Of_CEO_MD_President_Owner, LastName_Of_CEO_MD_President_Owner, NameOnPanCard, PanNo, Tan, GSTNo, CompanyRegistrationNo, IECCode, AccountName, AccountNo, AccountType, BankName, BranchName, SwiftCode_IFSCCode, PreMobileNo, PreAlternateMobileNo, PreTelephoneNo, PreTelephoneNo1, renderServiceTypeList, IsItmeBilling, IsVendorBilling, IsApprovalRights, Email, Mobile, preMobile, EmpanelmentFee, HallZoneList, YearOfEstablishment, NoOfStaff, NoOfEventHandled, ShortDescription, USP, ClientEventList, showDDDetails, isEmailSend
) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            PrimaryEmail: PrimaryEmail != '' ? PrimaryEmail : null,
            Title_PersonIncharge: Title_PersonIncharge != '' ? Title_PersonIncharge : null,
            PersonIncharge: PersonIncharge != '' ? PersonIncharge : null,
            LastNamePersonIncharge: LastNamePersonIncharge != '' ? LastNamePersonIncharge : null,
            MobileNo: MobileNo != '' ? MobileNo : null,
            AlternateMobileNo: AlternateMobileNo != '' ? AlternateMobileNo : null,
            Telephone: Telephone != '' ? Telephone : null,
            Telephone1: Telephone1 != '' ? Telephone1 : null,
            CompanyName: CompanyName != '' ? CompanyName : null,
            Address1: Address1 != '' ? Address1 : null,
            Address2: Address2 != '' ? Address2 : null,
            City: City != '' ? City : null,
            State: State != '' ? State : null,
            Pin: Pin != '' ? Pin : null,
            CountryID: CountryID != '' ? CountryID : null,
            SecondaryEmail: SecondaryEmail != '' ? SecondaryEmail : null,
            Website: Website != '' ? Website : null,
            TeleFax: TeleFax != '' ? TeleFax : null,
            // RoleTD: RoleTD != '' ? RoleTD : null,
            Designation: Designation != '' ? Designation : null,
            Title_Name_Of_CEO_MD_President_Owner: Title_Name_Of_CEO_MD_President_Owner != '' ? Title_Name_Of_CEO_MD_President_Owner : null,
            Name_Of_CEO_MD_President_Owner: Name_Of_CEO_MD_President_Owner != '' ? Name_Of_CEO_MD_President_Owner : null,
            LastName_Of_CEO_MD_President_Owner: LastName_Of_CEO_MD_President_Owner != '' ? LastName_Of_CEO_MD_President_Owner : null,
            NameOnPanCard: NameOnPanCard != '' ? NameOnPanCard : null,
            PanNo: PanNo != '' ? PanNo : null,
            Tan: Tan != '' ? Tan : null,
            GSTNo: GSTNo != '' ? GSTNo : null,
            CompanyRegistrationNo: CompanyRegistrationNo != '' ? CompanyRegistrationNo : null,
            IECCode: IECCode != '' ? IECCode : null,
            AccountName: AccountName != '' ? AccountName : null,
            AccountNo: AccountNo != '' ? AccountNo : null,
            AccountType: AccountType != '' ? AccountType : null,
            BankName: BankName != '' ? BankName : null,
            BranchName: BranchName != '' ? BranchName : null,
            SwiftCode_IFSCCode: SwiftCode_IFSCCode != '' ? SwiftCode_IFSCCode : null,
            PreMobileNo: PreMobileNo != '' ? PreMobileNo : null,
            PreAlternateMobileNo: PreAlternateMobileNo != '' ? PreAlternateMobileNo : null,
            PreTelephoneNo: PreTelephoneNo != '' ? PreTelephoneNo : null,
            PreTelephoneNo1: PreTelephoneNo1 != '' ? PreTelephoneNo1 : null,
            ServiceTypeList: renderServiceTypeList,
            IsItmeBilling: IsItmeBilling,
            IsVendorBilling: IsVendorBilling,
            IsApprovalRights: IsApprovalRights == true || IsApprovalRights == 1 ? 1 : 0,
            Email: Email != '' ? Email : null,
            Mobile: Mobile != '' ? Mobile : null,
            preMobile: preMobile != '' ? preMobile : null,
            EmpanelmentFee: EmpanelmentFee != '' ? EmpanelmentFee : null,
            HallZoneList: HallZoneList,
            YearOfEstablishment: YearOfEstablishment != '' ? YearOfEstablishment : null,
            NoOfStaff: NoOfStaff != '' ? NoOfStaff : null,
            NoOfEventHandled: NoOfEventHandled != '' ? NoOfEventHandled : null,
            ShortDescription: ShortDescription != '' ? ShortDescription : null,
            USP: USP != '' ? USP : null,
            ClientEventList: ClientEventList != '' ? ClientEventList : null,
            DDDetails: showDDDetails,
            IsEmailSend: isEmailSend,
        }

        const res = await axiosPost(addVendorRegistrationUrl, params, headers)

        dispatch({
            type: ADD_VENDOR_REGISTRATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateVendorRegistration_action = (
    PrimaryEmail, Title_PersonIncharge, PersonIncharge, LastNamePersonIncharge, MobileNo, AlternateMobileNo, Telephone, Telephone1, CompanyName, Address1, Address2, City, State, Pin, CountryID, SecondaryEmail, Website, TeleFax, Designation, Title_Name_Of_CEO_MD_President_Owner, Name_Of_CEO_MD_President_Owner, LastName_Of_CEO_MD_President_Owner, NameOnPanCard, PanNo, Tan, GSTNo, CompanyRegistrationNo, IECCode, AccountName, AccountNo, AccountType, BankName, BranchName, SwiftCode_IFSCCode, PreMobileNo, PreAlternateMobileNo, PreTelephoneNo, PreTelephoneNo1, AccountID, renderServiceTypeList, IsItmeBilling, IsVendorBilling, IsApprovalRights, Email, Mobile, preMobile, EmpanelmentFee, HallZoneList, YearOfEstablishment, NoOfStaff, NoOfEventHandled, ShortDescription, USP, ClientEventList, showDDDetails
) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            PrimaryEmail: PrimaryEmail != '' ? PrimaryEmail : null,
            Title_PersonIncharge: Title_PersonIncharge != '' ? Title_PersonIncharge : null,
            PersonIncharge: PersonIncharge != '' ? PersonIncharge : null,
            LastNamePersonIncharge: LastNamePersonIncharge != '' ? LastNamePersonIncharge : null,
            MobileNo: MobileNo != '' ? MobileNo : null,
            AlternateMobileNo: AlternateMobileNo != '' ? AlternateMobileNo : null,
            Telephone: Telephone != '' ? Telephone : null,
            Telephone1: Telephone1 != '' ? Telephone1 : null,
            CompanyName: CompanyName != '' ? CompanyName : null,
            Address1: Address1 != '' ? Address1 : null,
            Address2: Address2 != '' ? Address2 : null,
            City: City != '' ? City : null,
            State: State != '' ? State : null,
            Pin: Pin != '' ? Pin : null,
            CountryID: CountryID != '' ? CountryID : null,
            SecondaryEmail: SecondaryEmail != '' ? SecondaryEmail : null,
            Website: Website != '' ? Website : null,
            TeleFax: TeleFax != '' ? TeleFax : null,
            // RoleTD: RoleTD != '' ? RoleTD : null,
            Designation: Designation != '' ? Designation : null,
            Title_Name_Of_CEO_MD_President_Owner: Title_Name_Of_CEO_MD_President_Owner != '' ? Title_Name_Of_CEO_MD_President_Owner : null,
            Name_Of_CEO_MD_President_Owner: Name_Of_CEO_MD_President_Owner != '' ? Name_Of_CEO_MD_President_Owner : null,
            LastName_Of_CEO_MD_President_Owner: LastName_Of_CEO_MD_President_Owner != '' ? LastName_Of_CEO_MD_President_Owner : null,
            NameOnPanCard: NameOnPanCard != '' ? NameOnPanCard : null,
            PanNo: PanNo != '' ? PanNo : null,
            Tan: Tan != '' ? Tan : null,
            GSTNo: GSTNo != '' ? GSTNo : null,
            CompanyRegistrationNo: CompanyRegistrationNo != '' ? CompanyRegistrationNo : null,
            IECCode: IECCode != '' ? IECCode : null,
            AccountName: AccountName != '' ? AccountName : null,
            AccountNo: AccountNo != '' ? AccountNo : null,
            AccountType: AccountType != '' ? AccountType : null,
            BankName: BankName != '' ? BankName : null,
            BranchName: BranchName != '' ? BranchName : null,
            SwiftCode_IFSCCode: SwiftCode_IFSCCode != '' ? SwiftCode_IFSCCode : null,
            PreMobileNo: PreMobileNo != '' ? PreMobileNo : null,
            PreAlternateMobileNo: PreAlternateMobileNo != '' ? PreAlternateMobileNo : null,
            PreTelephoneNo: PreTelephoneNo != '' ? PreTelephoneNo : null,
            PreTelephoneNo1: PreTelephoneNo1 != '' ? PreTelephoneNo1 : null,
            AccountID: AccountID,
            ServiceTypeList: renderServiceTypeList,
            IsItmeBilling: IsItmeBilling,
            IsVendorBilling: IsVendorBilling,
            IsApprovalRights: IsApprovalRights == true || IsApprovalRights == 1 ? 1 : 0,
            Email: Email != '' ? Email : null,
            Mobile: Mobile != '' ? Mobile : null,
            preMobile: preMobile != '' ? preMobile : null,
            EmpanelmentFee: EmpanelmentFee != '' ? EmpanelmentFee : null,
            HallZoneList: HallZoneList,
            YearOfEstablishment: YearOfEstablishment != '' ? YearOfEstablishment : null,
            NoOfStaff: NoOfStaff != '' ? NoOfStaff : null,
            NoOfEventHandled: NoOfEventHandled != '' ? NoOfEventHandled : null,
            ShortDescription: ShortDescription != '' ? ShortDescription : null,
            USP: USP != '' ? USP : null,
            ClientEventList: ClientEventList != '' ? ClientEventList : null,
            DDDetails: showDDDetails,
            isMailSend: sessionStorage.getItem("RoleIDSS") != 7,
        }

        const res = await axiosPost(updateVendorRegistrationUrl, params, headers)

        dispatch({
            type: UPDATE_VENDOR_REGISTRATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteVendorRegistration_action = (AccountId) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            AccountId: AccountId
        }

        const res = await axiosGet(deleteVendorRegistrationUrl, params, headers)

        dispatch({
            type: DELETE_VENDOR_REGISTRATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDetailsVendorRegistration_action = (userId) => async (dispatch) => {
    try {
        const params = {
            UserID: userId,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        }

        const res = await axiosGet(detailsVendorRegistrationUrl, params, headers)

        dispatch({
            type: DETAILS_VENDOR_REGISTRATION,
            payload: res,
        });
        console.log("res---------------->", res)
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const sendVendorUserCred_action = (userId, AccountID) => async (dispatch) => {
    try {
        const params = {
            UserID: userId,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            AccountID: AccountID,
        }

        const res = await axiosGet(sendVendorUserCredUrl, params, headers)

        dispatch({
            type: SEND_VENDOR_CRED_REGISTRATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertVendorConfiguration_action = (vendorMapping, vendorConfiguration, vendorConfigMapping) => async (dispatch) => {
    try {
        const params = {
            vendorMapping: vendorMapping,
            vendorCOnfiguration: vendorConfiguration,
            vendorConfigMapping: vendorConfigMapping
        }

        const res = await axiosPost(insertVendorConfigurationUrl, params, headers)

        dispatch({
            type: INSERT_VENDOR_CONFIGURATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}